import { DeviceFamily, Placement } from '@amzn/fire-tv-campaign-automation-service';
import { STAGE } from 'src/constants';
import { mergeConfig } from 'src/utils/ConfigUtils';

type DeviceFamilyPlacementConfig = Record<DeviceFamily, Placement[]>;

const DEFAULT_CONFIG: DeviceFamilyPlacementConfig = {
  [DeviceFamily.FIRE_TV]: [Placement.FEATURE_ROTATOR],
  [DeviceFamily.FIRE_TABLETS]: [Placement.FEATURE_ROTATOR],
};

const STAGE_OVERRIDES: Partial<Record<STAGE, Partial<DeviceFamilyPlacementConfig>>> = {
  [STAGE.DEV]: {
    [DeviceFamily.FIRE_TV]: [Placement.FEATURE_ROTATOR, Placement.SCREEN_SAVER],
  },
  [STAGE.BETA]: {
    [DeviceFamily.FIRE_TV]: [Placement.FEATURE_ROTATOR, Placement.SCREEN_SAVER],
  },
  [STAGE.GAMMA]: {
    [DeviceFamily.FIRE_TV]: [Placement.FEATURE_ROTATOR, Placement.SCREEN_SAVER],
  },
};

export const getPlacementsForDeviceFamily = (
  deviceFamily: DeviceFamily,
  stage: STAGE,
): Placement[] => {
  const config = mergeConfig(DEFAULT_CONFIG, STAGE_OVERRIDES[stage]);
  return config[deviceFamily] || [];
};
